module.exports = __webpack_public_path__ + "img/website-election-details.cc3adb04.png";